// Экран «Общее» (владелец 2026-09-15, #96): настройки и сводка проекта целиком.
// Сводка по этапам работ — начало,
// окончание, длительность, сколько задач закончено. Даты — сохранённые, после «Актуализировать».
// Календари с праздниками — отдельной задачей после обсуждения (правка ядра расчёта, #62).
import { useCallback, useEffect, useState } from 'react';
import { call, p, type Data } from '../api';
import type { ShellCtx } from '../shell';
import { fmt } from '../util';
import { MspExport } from '../MspExport';

type Svodka = Data<'/api/projects/{pid}/etapy-svodka', 'get'>;
type Project = Data<'/api/projects', 'get'>[number];

export function Obshchee({ ctx }: { ctx: ShellCtx }) {
  const [svodka, setSvodka] = useState<Svodka | null>(null);
  const [start, setStart] = useState('');
  const [aktual, setAktual] = useState<string | null>(null);

  const load = useCallback(async () => {
    const [s, pr] = await Promise.all([
      call<Svodka>('get', p('/api/projects/{pid}/etapy-svodka', { pid: ctx.pid })),
      call<Project[]>('get', '/api/projects'),
    ]);
    if (s.ok) setSvodka(s.data); else ctx.onError?.(s.error.message);
    if (pr.ok) {
      const cur = pr.data.find(x => x.id === ctx.pid);
      setStart(cur?.start ? fmt(cur.start) : '');
      setAktual(cur?.aktual ?? null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.pid, ctx.reloadToken]);
  useEffect(() => { void load(); }, [load]);


  const stroki = svodka?.stroki || [];
  const dd = (x?: string | null) => (x ? fmt(x) : '—');
  const nach = stroki.map(s => s.nachalo).filter(Boolean).sort()[0] || null;
  const okon = stroki.map(s => s.okonchanie).filter(Boolean).sort().slice(-1)[0] || null;
  const vsego = stroki.reduce((a, s) => a + s.zadach, 0);
  const zav = stroki.reduce((a, s) => a + s.zaversheno, 0);
  const dni = (a: string | null, b: string | null) =>
    (a && b ? Math.round((Date.parse(b) - Date.parse(a)) / 86400000) : null);
  const aktualTekst = aktual ? new Date(aktual).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' })
    : 'не пересчитывался';

  return (
    <div className="ob-ekran">
      <MspExport ctx={ctx} />
      <div className="pw-section">Проект</div>
      <div className="pw-card ob-proekt">
        {/* старт и праздники переехали в «⚙ Настройки проекта» слева (2026-10-17) — здесь только показ */}
        <div className="ob-pole" title="Меняется в «⚙ Настройки проекта» рядом со списком проектов">
          <span className="wc-lab">Старт проекта</span>
          <span>{start || 'не задан'}</span>
        </div>
        <div className="ob-pole">
          <span className="wc-lab">Даты пересчитаны</span>
          <span>{aktualTekst}</span>
        </div>
      </div>

      <div className="pw-section">Этапы работ</div>
      <table className="pw-table ob-etapy">
        <thead>
          <tr>
            <th>Этап</th>
            <th className="num">Работ</th>
            <th className="num">Задач</th>
            <th className="num">Начало</th>
            <th className="num">Окончание</th>
            <th className="num">Длит., дн</th>
            <th className="num" title="Задач, законченных по факту">Закончено</th>
          </tr>
        </thead>
        <tbody>
          {!svodka && <tr><td colSpan={7} className="muted">Загрузка…</td></tr>}
          {svodka && !stroki.length && <tr><td colSpan={7} className="muted">Задач в проекте нет.</td></tr>}
          {stroki.map(s => (
            <tr key={s.etap}>
              <td>{s.etap}</td>
              <td className="num">{s.rabot}</td>
              <td className="num">{s.zadach}</td>
              <td className="num">{dd(s.nachalo)}</td>
              <td className="num">{dd(s.okonchanie)}</td>
              <td className="num">{s.dlit ?? '—'}</td>
              <td className="num">{s.zaversheno}{s.zadach ? ' (' + Math.round(s.zaversheno * 100 / s.zadach) + ' %)' : ''}</td>
            </tr>
          ))}
          {stroki.length > 1 && (
            <tr className="ob-itog">
              <td>Весь проект</td>
              <td className="num">{stroki.reduce((a, s) => a + s.rabot, 0)}</td>
              <td className="num">{vsego}</td>
              <td className="num">{dd(nach)}</td>
              <td className="num">{dd(okon)}</td>
              <td className="num">{dni(nach, okon) ?? '—'}</td>
              <td className="num">{zav}{vsego ? ' (' + Math.round(zav * 100 / vsego) + ' %)' : ''}</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="pw-muted" style={{ marginTop: 8 }}>
        Даты — по последнему пересчёту модели. Этап работы задаётся в справочнике «Работы».
      </div>

      <div className="pw-muted" style={{ marginTop: 12 }}>
        Старт проекта и праздники — в «⚙ Настройки проекта» рядом со списком проектов.
      </div>
    </div>
  );
}
